import React, { useEffect, useRef, useState } from "react";

import { LinearLoader } from "@braintrust/braintrust-ui-components";
import { useAppSelector } from "@js/hooks";

import styles from "./style.module.scss";

// Once shown, stays visible for a minimum duration, and hiding is delayed
// after loading finishes — avoids it disappearing and reappearing for
// quick/back-to-back requests.
const MIN_VISIBLE_MS = 250;
const HIDE_DELAY_MS = 100;

const RequestLoader = () => {
  const loading = useAppSelector((state) => state.requestLoader.loading);
  const hideRequestLoader = useAppSelector(
    (state) => state.requestLoader.hideRequestLoader,
  );
  const shouldLoad = loading && !hideRequestLoader;

  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef<number | null>(null);

  useEffect(() => {
    if (hideRequestLoader) {
      shownAtRef.current = null;
      setVisible(false);
      return;
    }

    if (shouldLoad && visible) {
      return;
    }

    if (shouldLoad) {
      shownAtRef.current = Date.now();
      setVisible(true);
      return;
    }

    if (!visible) {
      return;
    }

    const elapsed = shownAtRef.current ? Date.now() - shownAtRef.current : 0;
    const remaining = Math.max(MIN_VISIBLE_MS - elapsed, HIDE_DELAY_MS);
    const hideTimer = setTimeout(() => {
      shownAtRef.current = null;
      setVisible(false);
    }, remaining);

    return () => {
      clearTimeout(hideTimer);
    };
  }, [hideRequestLoader, shouldLoad, visible]);

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.requestLoader}>
      <LinearLoader color="secondary" />
    </div>
  );
};

export default RequestLoader;
